<div class="gpx-wrap">
  <section class="gpx-kartya">
    <header class="gpx-fej">
      <div class="gpx-fej-ikon"><ion-icon name="navigate-outline"></ion-icon></div>
      <div class="gpx-fej-szoveg">
        <h1>Út rögzítése GPS-szel</h1>
        <p>Indítsd el az utat, a végén állítsd le – a szakaszokból magától készül a menetlevél.</p>
      </div>
    </header>

    <!-- Nincs cég -->
    <div class="gpx-ures" *ngIf="!u">
      <ion-icon name="business-outline"></ion-icon>
      <p>Előbb válassz céget a modul fejlécében.</p>
    </div>

    <!-- KÉSZENLÉT: paraméterek + indítás -->
    <div class="gpx-urlap" *ngIf="u && allapot === 'keszenlet'">
      <ion-item>
        <ion-label position="stacked">Jármű</ion-label>
        <ion-select [(ngModel)]="jarmuId" interface="popover" placeholder="Válassz járművet">
          <ion-select-option *ngFor="let j of aktivJarmuvek" [value]="j.id">{{ j.rendszam }}{{ j.gyartmany ? ' – ' + j.gyartmany : '' }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Sofőr</ion-label>
        <ion-select [(ngModel)]="soforId" interface="popover" placeholder="(nincs megadva)">
          <ion-select-option [value]="''">(nincs)</ion-select-option>
          <ion-select-option *ngFor="let s of aktivSoforok" [value]="s.id">{{ s.nev }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Jelleg</ion-label>
        <ion-select [(ngModel)]="jelleg" interface="popover">
          <ion-select-option value="uzleti">Üzleti</ion-select-option>
          <ion-select-option value="magan">Magán</ion-select-option>
          <ion-select-option value="munkaba">Munkába járás</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Az út célja (nem kötelező)</ion-label>
        <ion-input [(ngModel)]="cel" placeholder="Pl. Üzleti megbeszélés"></ion-input>
      </ion-item>

      <ion-button expand="block" class="gpx-fo-gomb" [disabled]="!jarmuId" (click)="indit()">
        <ion-icon slot="start" name="play-circle-outline"></ion-icon> Út indítása
      </ion-button>
      <p class="gpx-tipp">A rögzítés a telefon helymeghatározását használja. Tartsd előtérben az appot – háttérbe téve a követés szünetelhet.</p>
    </div>

    <!-- RÖGZÍTÉS: élő kijelző -->
    <div class="gpx-rogzit" *ngIf="u && allapot === 'rogzit'">
      <div class="gpx-elo">
        <div class="gpx-elo-fo">
          <span class="gpx-km">{{ (osszKm | number:'1.1-1') }}</span><span class="gpx-km-e">km</span>
        </div>
        <div class="gpx-elo-meta">
          <span><ion-icon name="time-outline"></ion-icon> {{ eltelt }}</span>
          <span><ion-icon name="locate-outline"></ion-icon> {{ pontossag != null ? pontossag + ' m' : 'GPS-re vár…' }}</span>
          <span><ion-icon name="ellipse-outline"></ion-icon> {{ pontDb }} pont</span>
        </div>
      </div>

      <ul class="gpx-allomasok">
        <li *ngFor="let a of allomasok; let i = index">
          <ion-icon [name]="i === 0 ? 'flag-outline' : 'location-outline'"></ion-icon>
          <span class="gpx-all-nev">{{ a.cimke }}</span>
          <span class="gpx-all-km">{{ (a.km | number:'1.1-1') }} km</span>
        </li>
      </ul>

      <div class="gpx-gombsor">
        <ion-button expand="block" fill="outline" (click)="allomas()">
          <ion-icon slot="start" name="add-circle-outline"></ion-icon> Állomás hozzáadása
        </ion-button>
        <ion-button expand="block" color="success" [disabled]="mentFut" (click)="leallit()">
          <ion-icon slot="start" name="stop-circle-outline"></ion-icon> Leállítás és mentés
        </ion-button>
        <ion-button expand="block" fill="clear" color="medium" size="small" [disabled]="mentFut" (click)="megszakit()">
          Megszakítás mentés nélkül
        </ion-button>
      </div>
    </div>
  </section>
</div>
